import { useEffect } from 'react';
import { useAdminUsersStore } from '../../store/adminUsersStore';
import type { User } from '../../types';

interface Props {
  id: string;
  excludeUserId?: string;
  value: string;
  /** Currently assigned rep, kept selectable even if no longer an active Sales Rep. */
  current?: { id: string; displayName: string | null } | null;
  onChange: (id: string) => void;
}


export function WorksForSelect({ id, excludeUserId, value, current, onChange }: Props) {
  const salesReps = useAdminUsersStore((st) => st.salesReps);
  const salesRepsError = useAdminUsersStore((st) => st.salesRepsError);
  const fetchSalesReps = useAdminUsersStore((st) => st.fetchSalesReps);
  useEffect(() => {
    void fetchSalesReps();
  }, [fetchSalesReps]);
  const options = salesReps.filter(
    (u: User) => u.isActive && u.roles.includes('SALES_REP') && u.id !== excludeUserId,
  );
  return (
    <div>
      <label htmlFor={id} className="text-xs font-medium text-gray-600 dark:text-gray-300">
        Works for *
      </label>
      <select
        id={id}
        className="mt-1 w-full rounded border border-gray-300 bg-white px-3 py-1.5 text-sm dark:border-gray-600 dark:bg-gray-800"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select a sales rep…</option>
        {current && !options.some((u) => u.id === current.id) && (
          <option value={current.id}>{current.displayName ?? 'Unnamed rep'}</option>
        )}
        {options.map((u) => (
          <option key={u.id} value={u.id}>
            {u.displayName ?? u.email}
          </option>
        ))}
      </select>
      {salesRepsError ? (
        <p className="mt-1 text-xs text-red-600 dark:text-red-400">Couldn't load sales reps.</p>
      ) : (
        options.length === 0 &&
        !current && <p className="mt-1 text-xs text-gray-500">No active sales reps found.</p>
      )}
    </div>
  );
}
